<div class="w-full h-full">
    <!-- Filter Form -->
    <div class="w-900-px mx-auto">
        <form [formGroup]="form">
            <div class="grid grid-cols-8 gap-3 mt-5">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <span class="text-xs w-130-px font-semibold">
                            User Name:
                        </span>
                        <input 
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic" 
                            formControlName="username" 
                            type="text" 
                            placeholder="User Name">
                    </div>
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <app-date-input 
                            class="w-full text-black"
                            label="Date From:"
                            [parentForm]="form"
                            controlName="dateFrom" 
                        >
                        </app-date-input> 
                    </div>
                </div>

                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <span class="text-xs w-130-px font-semibold">
                            Portal Page / Tab:
                        </span>
                        <app-dropdown-field
                            [options]="tabOptions"
                            [selectedText]="portalTab_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setPortalTabType($event.label, $event.value)"
                        ></app-dropdown-field>
                    </div>
                    <div class="card-input flex items-center text-xs py-2 w-full mb-3">
                        <app-date-input 
                            class="w-full text-black"
                            label="Date To:"
                            [parentForm]="form"
                            controlName="dateTo" 
                        >
                        </app-date-input> 
                    </div>
                </div>
            </div>
        </form>
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button 
                (click)="submit()" 
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
    </div>

    <!-- enhancement table layout if needed later if want to implement a data table display with pagination, search and sorting functionality -->
    <div class="w-full maxh-550-px py-4 overflow-x-auto w-table mt-5" *ngIf="submitted">
        <ng-container *ngIf="showTable">
            <div class="bg-light-orange w-full flex items-center justify-between space-x-3 pr-3 pt-4 text-sm mt-10" *ngIf="submitted && showTable">
                <div class="flex items-center pl-6" [formGroup]="limitForm">
                    <div class="orange-text text-xs">Show</div>
                        <input 
                            class="orange-input focus:outline-none text-center mx-1 w-25-px text-xs p-1"
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            formControlName="limit"
                            (change)="onLimitChangeFromComponent($event)"
                            placeholder="">
                        <div class="orange-text text-xs">entries</div>
                </div>
            </div>
            <div class="data-table">
                <app-data-table
                    [tableHeader]="tableHeader"
                    [tableSubHeader]="tableSubHeader"
                    [isLoading]="isLoading"
                    [sort_type]="sort_type"
                    (toggleOnSort)="sortList($event.key, $event.type)">
                    
                    <ng-container *ngIf="logsList?.length > 0">
                        <tr class="focus:outline-none" *ngFor="let log of logsList">
                            <td>{{ log.dateTaken | date:'yyyy-dd-MM hh:mm:ss' | nullWithDefault }}</td>
                            <td>{{ log.portalTab | nullWithDefault }}</td>
                            <td>{{ log.actionMade | nullWithDefault }}</td>
                            <td>{{ log.actionTakenBy | nullWithDefault }}</td>
                            <td>{{ log.username | nullWithDefault }}</td>
                        </tr>
                    </ng-container>
                </app-data-table>

                <app-pagination
                    [currentPage]="current_page"
                    [totalPages]="total_pages"
                    [pageSize]="size"
                    [totalItems]="total"
                    [pages]="pages_array"
                    (pageChange)="setPage($event)"
                    (previousPage)="prevPage()"
                    (nextPage)="nextPage()"
                    showTotalEntries="true"
                    [isFirstPage]="current_page === 1"
                    [isLastPage]="current_page === total_pages"
                ></app-pagination>
            </div>
        </ng-container>
    </div>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>

<!-- enhancement table layout if needed later if want to implement a data table display with pagination, search and sorting functionality -->
<!-- <div class="w-full maxh-550-px py-4 overflow-x-auto w-table mt-5" *ngIf="submitted">
    <app-table-controls
        [currentLimit]="option === 1 ? size : (option === 2 ? size_filter : size_filter2)"
        [searchPlaceholder]="'Search portal user logs'"
        (limitChangeEvent)="onLimitChangeFromComponent($event)"
        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
        (keydownEvent)="keyDownFunction($event)"
        [showSearchControl]="false"
    ></app-table-controls>

    <app-data-table
        [tableHeader]="tableHeader"
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
    >
        <ng-container *ngIf="!itemLists_filter && !itemLists_filter2">
            <tr class="focus:outline-none" *ngFor="let item of itemLists">
                <td>{{item.dateTaken | date:'yyyy-MM-dd HH:mm:ss' | nullWithDefault}}</td>
                <td>{{ item.portalTab | nullWithDefault }}</td>
                <td>{{ item.actionMade | nullWithDefault}}</td>
                <td>{{ item.actionTakenBy | nullWithDefault }}</td>
                <td>{{ item.username | nullWithDefault }}</td>
            </tr>
        </ng-container>

        <ng-container *ngIf="itemLists_filter">
            <tr class="focus:outline-none" *ngFor="let item of itemLists_filter">
                <td>{{item.dateTaken | date:'yyyy-MM-dd HH:mm:ss' | nullWithDefault}}</td>
                <td>{{ item.portalTab | nullWithDefault }}</td>
                <td>{{ item.actionMade | nullWithDefault}}</td>
                <td>{{ item.actionTakenBy | nullWithDefault }}</td>
                <td>{{ item.username | nullWithDefault }}</td>
            </tr>
        </ng-container>

        <ng-container *ngIf="itemLists_filter2">
            <tr class="focus:outline-none" *ngFor="let item of itemLists_filter2">
                <td>{{item.dateTaken | date:'yyyy-MM-dd HH:mm:ss' | nullWithDefault}}</td>
                <td>{{ item.portalTab | nullWithDefault }}</td>
                <td>{{ item.actionMade | nullWithDefault}}</td>
                <td>{{ item.actionTakenBy | nullWithDefault }}</td>
                <td>{{ item.username | nullWithDefault }}</td>
            </tr>
        </ng-container>
    </app-data-table>

    <app-pagination
        [currentPage]="option === 1 ? current_page : (option === 2 ? current_page_filter : current_page_filter2)"
        [totalPages]="option === 1 ? total_pages : (option === 2 ? total_pages_filter : total_pages_filter2)"
        [pageSize]="option === 1 ? size : (option === 2 ? size_filter : size_filter2)"
        [totalItems]="option === 1 ? total : (option === 2 ? total_filter : total_filter2)"
        (pageChange)="setPage($event)"
        (previousPage)="prevPage()"
        (nextPage)="nextPage()"
        showTotalEntries="true"
    ></app-pagination>
</div> -->